import { Button, Icon } from '@wordpress/components';
import { dragHandle } from '@wordpress/icons';
import { useState } from '@wordpress/element';

const CustomPanel = ({ index, label, isOpenDefault = false, onToggle, children, dragAttributes, dragListeners }) => {
    const [isOpen, setIsOpen] = useState(isOpenDefault);

    const toggleOpen = () => {
        const newOpen = !isOpen;
        setIsOpen(newOpen);
        onToggle?.(newOpen);
    };

    return (
        <div className="voxycure-drag__inner-panel">
            <div
                className={`voxycure-drag__panel-header ${isOpen ? 'is-open' : ''}`}
                onClick={toggleOpen}
            >
                <div
                    {...dragListeners}
                    {...dragAttributes}
                    className="voxycure-drag__panel-drag-icon"
                    title="Drag to reorder"
                    onClick={(e) => e.stopPropagation()} // prevent toggle when clicking drag icon
                >
                    <Icon icon={dragHandle} />
                </div>
                <div className="voxycure-drag__panel-title">
                    <span className='voxycure-drag__panel-order'>{index + 1}</span>
                    <span>{label}</span>
                </div>
                <Button
                    isSmall
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleOpen();
                    }}
                >
                    {isOpen ? 'Collapse' : 'Expand'}
                </Button>
            </div>
            {isOpen && <div className="custom-panel-body">{children}</div>}
        </div>
    );
};

export default CustomPanel;
